import React, { useState } from 'react';
import { InputGroup, Input, InputGroupAddon, InputGroupText, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useICOReferralIncome } from './api/index';
import moment from 'moment';
import { useDebounce } from '../../../hook/debounce';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useToast } from '../../../hook/usetoast';
import { Check } from 'lucide-react';
import Loader from '../../Loader/buttonLoad';
import { Footer } from '../../../components/footer';
import { useNavigate } from 'react-router-dom';

const MoveReferralIncome = () => {

    const [page, setPage] = useState(0);
    const navigate = useNavigate()
    const [search, setSearch] = useState('')
    const debouncedText = useDebounce(search)
    const toast = useToast();
    const [uniqueId, setUniqueId] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { data: userHistory , isLoading } = useICOReferralIncome({
        page,
        size: rowsPerPage,
        type: "MoveReferCommission",
        search: debouncedText
    })
    const copyuserAddress = async data => {
        setUniqueId(data?._id)
        await copyToClipboard(data?.memberIdby)
        toast.success("Copied Successfully")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }
    const totalPages = Math.ceil(userHistory?.count / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };
    return (
        <div>
            <div className="mainContent">
                {(isLoading) && <Loader />}
                <div className="pageContent def-py-30">

                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/redeem-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Move to Stake Income</span>
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">

                                        <div>
                                            <div className="px-4 mb-3">
                                                <div className='row justify-content-between'>
                                                    <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                        <div className='d-inline-flex g-8 align-items-center'>
                                                            <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                            <div className='form-group mb-0 formInputs gradientBg'>
                                                                <select className='form-control' value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
                                                                    <option value="10">10</option>
                                                                    <option value="30">30</option>
                                                                    <option value="50">50</option>
                                                                </select>
                                                            </div>
                                                            <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='form-inline justify-content-md-end justify-content-center'>
                                                            <div className="formInputs form-group gradientBg">
                                                                <InputGroup>
                                                                    <InputGroupAddon addonType="prepend" tag='div'>
                                                                        <InputGroupText className='pl-0'>
                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="white" strokeOpacity="0.6" strokeLinecap="round" />
                                                                                <path d="M15.75 15.75L11.25 11.25" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <Input type='text' placeholder='Search' onChange={(e) => setSearch(e.target.value)} />
                                                                </InputGroup>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='table-responsive mb-3'>
                                                <table className='table myapptable table-hover table-borderless mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th className='pl-4 text-nowrap'>User ID</th>
                                                            <th>Username</th>
                                                            <th>Level</th>
                                                            <th className='text-nowrap'>Referral Income</th>
                                                            <th>Wallet</th>
                                                            <th className='text-nowrap'>Date & Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            userHistory?.data && userHistory.data.length > 0 ? (
                                                                userHistory.data.map((v, i) => (
                                                                    <tr key={v?._id}>
                                                                        <td className='pl-4'>
                                                                            {v?.memberIdby}
                                                                            {(uniqueId === v?._id) ? (
                                                                                <Check size={20} color={"#FCD535"} cursor={'not-allowed'} />
                                                                            ) : (
                                                                                <button
                                                                                    type="button"
                                                                                    aria-label="Copy ID"
                                                                                    onClick={() => copyuserAddress(v)}
                                                                                    onKeyDown={(e) => e.key === 'Enter' && copyuserAddress(v)}
                                                                                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                                                                >
                                                                                    <img src={require('../../../assets/images/master-wallet/copyIcon.svg').default} alt='copyIcon' />
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                        <td>{v?.usernameby ? v?.usernameby : "--"}</td>
                                                                        <td className='text-nowrap'>Level {v?.level}</td>
                                                                        <td className='text-nowrap'>{(v?.amount)?.toString().includes('.') ? parseFloat(v?.amount)?.toFixed(5).replace(/(\.0+)?$/, '') : v?.amount} <span className="text-white-60">USDT</span></td>
                                                                        <td>{v?.walletName}</td>
                                                                        <td className='pr-4 text-nowrap'>
                                                                            <span>{moment(v.createdAt).format("DD/MM/YYYY | hh:mm A")}</span>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center">No data found</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="px-4">
                                                <div className='row'>
                                                    <div className='col-lg-12'>

                                                        <Pagination aria-label="Page navigation" className='customPagination'>
                                                            <PaginationItem disabled={page === 0}>
                                                                <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                                    <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                                </PaginationLink>
                                                            </PaginationItem>

                                                            {Array.from({ length: totalPages }, (_, index) => (
                                                                <PaginationItem key={index} active={index === page}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                        {index + 1}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            ))}

                                                            <PaginationItem disabled={page === totalPages - 1}>
                                                                <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                                    Next <i className='bi bi-arrow-right align-bottom'></i>
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        </Pagination>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
            </div>
        </div   >
    )
}

export default MoveReferralIncome;